import { useEffect, type JSX } from "react";

/**
 * Full-page navigation to a same-origin backend route.
 *
 * A `/api/*` path (e.g. the OAuth consent resume `/api/oauth/v1/authorize`) is
 * served by the backend, not the SPA router, so react-router `<Navigate>` /
 * `navigate()` can't reach it. Rendered as a component (not called inline) so
 * the `useEffect` obeys the rules of hooks. Use `isBackendRoute(target)` to
 * decide whether to render this instead of a normal react-router navigation.
 */
export function BackendRedirect({ to }: { to: string }): JSX.Element | null {
  useEffect(() => {
    window.location.assign(to);
  }, [to]);
  return null;
}
